<template>
    <v-switch :label="$t(`filters.labels.${name}`)" v-model="model"></v-switch>
</template>

<script>
export default {
    props: ['name', 'resource'],

    computed: {
        key() {
            return [this.resource, this.name].join('.')
        },
        model: {
            get() {
                return this.$store.getters['filters/getByDotNotation'](this.key)
            },
            set(value) {
                if (!value) {
                    this.$store.commit('filters/unset', {
                        resource: this.resource,
                        name: this.name,
                    })
                    return
                }

                this.$store.commit('filters/apply', {
                    resource: this.resource,
                    filter: { name: this.name, value: value },
                })
            },
        },
    },
}
</script>

<style></style>
